import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { Component, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

/**
 * Reparto de los botones de una categoría en las TRES PANTALLAS que ve el vecino.
 *
 * Es el mismo dato que `categoria-armado` (Principales / Secundarios / Otros → `idsBtnsPrincipales`
 * / `idsBtnsSecundarios` / `idsOtrosBotones`), pero nombrado por lo que el vecino realmente ve:
 * pantalla 1 es la que se abre, la 2 y la 3 aparecen solo si tienen algo. El orden dentro de cada
 * pantalla es la prioridad.
 *
 * Las tres arrays se reciben POR REFERENCIA y se mutan in-place vía drag&drop (CDK), así el padre
 * ve los cambios sin eventos extra.
 */
@Component({
  selector: 'app-pantallas-armado',
  templateUrl: './pantallas-armado.component.html',
  styleUrls: ['./pantallas-armado.component.scss'],
  standalone: false,
})
export class PantallasArmadoComponent {
  /** FormArray de grupos de botón (cada uno con `_tmpId`, `nombre`, `funcion`...). */
  @Input() botones?: UntypedFormArray;
  @Input() idsPantalla1: string[] = [];
  @Input() idsPantalla2: string[] = [];
  @Input() idsPantalla3: string[] = [];

  /** Nombre + función del botón, para el chip. */
  public btnLabel(tmpId: string): string {
    const grupos = this.botones?.controls as UntypedFormGroup[] | undefined;
    const g = grupos?.find((c) => c.get('_tmpId')?.value === tmpId);
    if (!g) return tmpId;
    const nombre = g.get('nombre')?.value || 'sin nombre';
    const funcion = g.get('funcion')?.value;
    return funcion ? `${nombre} · ${funcion}` : nombre;
  }

  /** Botones que no quedaron en ninguna pantalla: no se muestran en la app. */
  get sueltos(): string[] {
    const grupos = (this.botones?.controls ?? []) as UntypedFormGroup[];
    const asignados = new Set([
      ...this.idsPantalla1,
      ...this.idsPantalla2,
      ...this.idsPantalla3,
    ]);
    return grupos
      .map((g) => String(g.get('_tmpId')?.value))
      .filter((id) => !asignados.has(id));
  }

  public drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }
}
